import { gql, useQuery } from '@apollo/client';

import user from 'js/lib/user';

import type {
  GetAllowedDomainsForUserAndFeatureRequest,
  GetAllowedDomainsForUserAndFeatureResponse,
} from '@coursera/grpc-types-enterprisepermissions/coursera/proto/enterprisepermissions/userpermissions/v1beta1/enterprise_user_permissions_api';

export const getAllowedDomainsForUserAndFeatureQuery = gql`
  query GetAllowedDomainsForUserAndFeatureQuery($input: GetAllowedDomainsForUserAndFeatureRequest!) {
    getDomains(input: $input)
      @rest(
        type: "GetAllowedDomainsForUserAndFeature"
        path: "grpc/enterprisepermissions/userpermissions/v1beta1/EnterpriseUserPermissionsAPI/GetAllowedDomainsForUserAndFeature"
        method: "POST"
      ) {
      domainIds
    }
  }
`;

export const useIsEnterpriseAdminAbleToAssignContent = ({
  ssr,
  userId = user.get().id,
  skip: skipFromCaller,
}: {
  ssr: boolean;
  userId?: number;
  skip?: boolean;
}) => {
  const skip = skipFromCaller || !userId;
  const { data } = useQuery<
    { getDomains: GetAllowedDomainsForUserAndFeatureResponse },
    { input: GetAllowedDomainsForUserAndFeatureRequest }
  >(getAllowedDomainsForUserAndFeatureQuery, {
    variables: {
      input: {
        userId,
        permission: {
          domain: 'FEATURE_DOMAIN_PROGRAM',
          subdomain: 'CONTENT_ASSIGNMENT',
          verb: 'EDIT',
        },
      },
    },
    skip,
    ssr,
  });

  const enterpriseAdminRoles = data?.getDomains?.domainIds ?? [];
  return enterpriseAdminRoles.length > 0;
};
